import { render, staticRenderFns } from "./RecoverySimulatorSelectedCategory.vue?vue&type=template&id=5a08e516"
import script from "./RecoverySimulatorSelectedCategory.vue?vue&type=script&lang=js"
export * from "./RecoverySimulatorSelectedCategory.vue?vue&type=script&lang=js"
import style0 from "./RecoverySimulatorSelectedCategory.vue?vue&type=style&index=0&id=5a08e516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports